import React from 'react';

export const CICompass = () => {
    return <svg className='ci' version="1.1" x="0" y="0" width="auto" viewBox="0, 0, 24, 24">
        <g id="compass" transform="translate(-0.5, -0.5)">
                <path className='ci-fill' d="M21,12 C21,7.029 16.971,3 12,3 C7.029,3 3,7.029 3,12 C3,16.971 7.029,21 12,21 C16.971,21 21,16.971 21,12 z"  />
                <path className='ci-stroke' d="M10.468,10.468 L16.608,8.392 L14.532,14.532 z M21.5,12.5 C21.5,17.471 17.471,21.5 12.5,21.5 C7.529,21.5 3.5,17.471 3.5,12.5 C3.5,7.529 7.529,3.5 12.5,3.5 C17.471,3.5 21.5,7.529 21.5,12.5 z M10.468,10.468 L8.392,16.608 L14.532,14.532 z" fillOpacity="0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
    </svg>
};